import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

export type FindingComment = {
  id: string
  findingId: string
  dataCollectionStatementId: string
  userRole: string
  message: string
  createdBy?: string
  createdAt?: string
}

export const getCommentsByFinding = async ({
  findingId,
  signal,
}: {
  findingId: string
  signal?: AbortSignal
}): Promise<FindingComment[]> => {
  const response = await apiClient.get(`${endpoints.findingComments}/findings/${findingId}`, {
    signal,
  })
  return unwrapCollection<FindingComment>(response)
}
